<div class="modal-container">
  <upload-modal-header></upload-modal-header>

  <mat-dialog-content>
    <loader-modal
      *ngIf="uploadModalService.uploading"
      [overlay]="true"></loader-modal>
    <ng-container *ngIf="!uploadModalService.uploading">
      <div
        *ngIf="!uploadModalService.showGenerateTemplate"
        class="modal__body text-center">
        <span class="modal-body-text">
          {{ data.body }}
        </span>
        <div class="flex flex-col items-center">
          <div class="mb-2">
            <mat-icon class="material-symbols-rounded"> insert_drive_file </mat-icon>
            <p
              class="file-name"
              *ngIf="uploadModalService.fileName">
              {{ uploadModalService.fileName }}
            </p>
          </div>
          <input
            hidden
            type="file"
            accept="{{ data.type === UploadType.WORD_OUTPUT ? '.docx' : '.xlsx' }}"
            #uploader
            (change)="uploadModalService.uploadFile($event)" />
          <button
            class="browse-btn"
            (click)="uploader.click()">
            Browse
          </button>
        </div>
        <div>
          <ul class="error-upload">
            <li *ngFor="let error of uploadModalService.errors">
              {{ uploadModalService.errorText[error.errorType]
              }}{{ error.additionalText ? ': ' + error.additionalText : '' }}.
            </li>
          </ul>
          <ul *ngIf="uploadModalService.showErrorList">
            <li><span style="color: #ff0000">Red</span> - Required</li>
            <li><span style="color: #0000ff">Blue</span> - Not Found</li>
            <li><span style="color: #00ff00">Green</span> - Duplicate</li>
            <li><span style="color: #a52a2a">Brown</span> - Not Valid</li>
          </ul>
        </div>
      </div>

      <div
        *ngIf="uploadModalService.showGenerateTemplate"
        class="modal__body">
        <div class="flex flex-col">
          <scope-ui-autocomplete
            class="mb-6"
            [options]="data.rateCards$ | async"
            orderBy="name"
            [label]="'Rate Card'"
            [required]="true"
            (onSelectionChange)="uploadModalService.selectedRateCard = $event.event" />
          <button
            mat-button
            class="confirm scope-ui-modal-flat-button"
            [disabled]="uploadModalService.selectedRateCard === null"
            (click)="uploadModalService.generateRateCardTemplate()">
            Generate Template
          </button>
        </div>

        <ng-container *ngIf="data.type !== UploadType.COMPONENT && data.type !== UploadType.FIXED_FEE_COMPONENT">
          <br />
          <small>
            * Or download the
            <a
              class="orange"
              (click)="uploadModalService.getTemplateExampleUrl()"
              target="_self">
              Generic Template
            </a>
          </small>
        </ng-container>

        <br />
        <br />
        <small>
          <a
            class="orange"
            (click)="uploadModalService.showGenerateTemplate = false">
            Go back to Upload a Template
          </a>
        </small>
      </div>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions *ngIf="!uploadModalService.showGenerateTemplate">
    <button
      mat-button
      class="confirm scope-ui-modal-flat-button"
      *ngIf="uploadModalService.errors.length == 0"
      (click)="uploadModalService.submit()">
      Upload
    </button>

    <p
      *ngIf="data.showRemoveOption"
      class="mt-4">
      <b>{{ data.removeOptionText }}</b>
      <a
        class="orange"
        (click)="data.removeFn()">
        Click here
      </a>
    </p>
  </mat-dialog-actions>
</div>
